import { ClientUserState } from '../ClientUserState.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
export function isMapLockedForUser(mapData) {
    var _ClientUserState_userState;
    if (mapData.mapEnum == UIUtilsEjsVariables.freeMap) return false;
    if (!mapData.isMapPremium()) return false;
    if ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items.hasAccessToPremiumMap(mapData)) return false;
    return true;
}
